
module.exports = require('./socket');

/**
 * Exports parser
 *
 * @api public
 *
 */
module.exports.parser = require('engine.io-parser');



//////////////////
// WEBPACK FOOTER
// ./~/octa-whatsapp/~/engine.io-client/lib/index.js
// module id = 96sx
// module chunks = 1